import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseNavigationTab } from 'src/app/shared-module/model/navigation.model';

@Component({
  selector: 'app-navigation-sub-tab',
  templateUrl: './navigation-sub-tab.component.html',
  styleUrls: ['./navigation-sub-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavigationSubTabComponent {
  @Input() navigationSubTab?: BaseNavigationTab;
}
